// thunk.js

import { loginSuccess, loginfailure, logout } from "./reducer";
import axios from "axios";
import toast from "react-hot-toast";
import _BaseAPIService from "../../../services/_BaseAPIService";
import { getLoggedInUser } from "../../../helpers/fakebackend_helper";

const apiUrl = window.APP_CONFIG.api1.baseapi + "/auth/login";
const authUser = getLoggedInUser();
console.log("authUserr", authUser);

export const login = (credentials, history) => async (dispatch) => {
  try {
    const response = await axios.post(apiUrl, credentials);
    console.log(response);
    const user = response;

    if (user) {
      // Store the user data and token first
      _BaseAPIService.storeToken(user.token);
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("token", user.token);
      // Get existing data
      let savedUsers = JSON.parse(localStorage.getItem("savedUsers")) || [];
      // Minimal info for saved users
      const newUser = {
        user: {
          email: user.user.email,
          roles: user.user.roles,
        },
      };
      const exists = savedUsers.some(
        (item) => item.user.email === newUser.user.email
      );
      if (!exists) {
        savedUsers.push(newUser);
        localStorage.setItem("savedUsers", JSON.stringify(savedUsers));
      }

      // Save back to localStorage
      // Dispatch login success before checking user type
      dispatch(loginSuccess(user));
      // const refreshInterval = _BaseAPIService.startRefreshTokenPolling();

      // Check user type from the response data instead of authUser
      const isSuperAdmin = user.user.roles.includes("SuperAdmin");
      const isOrgAdmin = user.user.roles.includes("OrgAdmin");
      const isKitchenAdmin = user.user.roles.includes("Kitchen");

      // Navigate based on user type
      if (isSuperAdmin) {
        history("/dashboard");
      } else if (isOrgAdmin) {
        history("/dashboard");
      } else if (isKitchenAdmin) {
        history("/kds");
      } else {
        history("/pos");
      }

      toast.success("Welcome to Ordering system");
    } else {
      dispatch(loginfailure());
      // toast.error("Invalid username or passw ord. Please try again.");
    }
  } catch (error) {
    dispatch(loginfailure());

    toast.error("Invalid username or password. Please try again.");
  }
};
export const logoutUser = () => (dispatch) => {
  // Clear the user data and token from local storage.
  localStorage.removeItem("user");
  localStorage.removeItem("token");
  localStorage.removeItem("lastCalendarView");

  // Dispatch the logout action.
  dispatch(logout());
};
